import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '@shared/services/storage.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  const storageService = inject(StorageService);
  if (!storageService.isLoggedIn()) {
    router.navigate(['home']);
    return false;
  }
  return true;
};

export const PublicRoutes: CanActivateFn = () => {
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (storageService.isLoggedIn()) {
    router.navigate(['/app/teams']);
    return false;
  }
  return true;
};
